var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: _vm.id,
        "dialog-class": "base-modal",
        scrollable: "",
        "hide-header": "",
        "hide-header-close": "",
        "hide-footer": "",
        "no-close-on-esc": "",
        "no-close-on-backdrop": "",
        centered: "",
      },
    },
    [
      _c("div", { staticClass: "title" }, [_vm._t("title")], 2),
      !_vm.noContent
        ? _c("div", { staticClass: "modal-content" }, [_vm._t("content")], 2)
        : _vm._e(),
      _c(
        "div",
        { staticClass: "btn-wrapper", class: { "cancel-on": _vm.cancelBtn } },
        [
          _vm.cancelBtn
            ? _c(
                "div",
                {
                  staticClass: "modal-btn cancel",
                  on: { click: _vm.clickCancel },
                },
                [
                  _vm._t("cancel", function () {
                    return [_vm._v(_vm._s(_vm.$t("modal.cancel")))]
                  }),
                ],
                2
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "modal-btn confirm",
              on: { click: _vm.clickConfirm },
            },
            [
              _vm._t("confirm", function () {
                return [_vm._v(_vm._s(_vm.$t("modal.confirm")))]
              }),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }